import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const ThirdPartyPropertyDamageExcess = (props) => {
  return (
    <FormGroup controlId="thirdPartyPropertyDamageExcess">
      <Col componentClass={ControlLabel} sm={5}>
        Third Party Property Damage Excess (HKD)
      </Col>
      <Col sm={7}>
          <FormControl
            type="text"
            autoComplete="off"
            maxLength="60"
            value={props.thirdPartyPropertyDamageExcess}
            onChange={props.handleChangeThirdPartyPropertyDamageExcess} />
      </Col>
    </FormGroup>
  )
}

ThirdPartyPropertyDamageExcess.propTypes = {
  thirdPartyPropertyDamageExcess: PropTypes.string,
  handleChangeThirdPartyPropertyDamageExcess: PropTypes.func
};

export default ThirdPartyPropertyDamageExcess;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/thirdPartyPropertyDamageExcess/ThirdPartyPropertyDamageExcess.js